/** ГПХ: латинская B или кириллическая В в табельном номере. */
export function isGphEmployee(employee): boolean {
  return !!employee && /[BВ]/i.test(String(employee.personnel_number || ''));
}

/** Первое известное значение, включая обычный номер, приоритетнее запасных данных. */
export function isGphFromSources(employees: any[]): boolean {
  const employee = employees.find((item) =>
    item && item.personnel_number !== undefined && item.personnel_number !== null
  );

  return isGphEmployee(employee);
}
